import { FormDialogTemplate } from "../../../../shared/form-dialog/form-dialog.template";
import { AuthenticationService } from "../../../../auth.service";
import { Subject, BehaviorSubject } from "rxjs";
import { FormBuilder, Validators } from "@angular/forms";
import { Injector } from "@angular/core";
import { FilterableService } from "../../../mesc/filterable-service";

import { BaseService } from "../../../mesc/mesc.service";
import { RequestDetailService } from "./detail.service";

export class UserDelegateTemplate extends FormDialogTemplate {
    private readonly dialogTitle: Subject<string> = new BehaviorSubject<string>('Delegate User');
    private readonly formBuilder: FormBuilder = this.injector.get(FormBuilder);
    private readonly authService: AuthenticationService = this.injector.get(AuthenticationService);
    private readonly userService: FilterableService = new FilterableService();
    private readonly baseService: BaseService = this.injector.get(BaseService);
    private readonly detailService: RequestDetailService = this.injector.get(RequestDetailService);

    constructor(private readonly injector: Injector) {
        super();

        this.authService.getActiveModule();

        this.editForm = this.formBuilder.group({
            WFTaskId: [],
            Email: ['', Validators.required],
            Name: [],
        });
        this.initilize(this.dialogTitle, this.editForm, this.userFormTabs);
    }

    userChange = (dataItem) => {
        const user = this.userService.value.find(u => u.Email === dataItem);
        if (user) this.editForm.get('Name').setValue(user.cn);
    }

    refreshUsers(role: string) {
        const module = this.detailService.module;
        this.baseService.read(`common/User/GetUsersByRoleCode/${module.Id}/${role.toUpperCase()}`)
            .then(x => this.userService.next(this.detailService.mapUsers(x)));
    }

    userFormControls: any[] = [{
        type: "combobox",
        title: "User",
        name: "Email",
        textField: "cn",
        valueField: "Email",
        service: this.userService,
        stretch: true,
        onChange: this.userChange
    }];

    userFormTabs = [
        {
            title: "Users",
            selected: true,
            formControls: this.userFormControls
        },
    ]

}
